import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-games-slider',
  templateUrl: './games-slider.component.html',
  styleUrls: ['./games-slider.component.css']
})
export class GamesSliderComponent implements OnInit {
  @Output() gameChange = new EventEmitter();
  selectedGame = 'Pubg Mobile';
  constructor() { }

  ngOnInit() {
  }

  onClick(game) {
    this.selectedGame = game;
    this.gameChange.emit(game);
  }
}
